<script>
import draggable from "vuedraggable";
import render from "../../components/render/render";

const components = {
  itemBtns(h, currentItem, index, list) {
    const { copyItem, deleteItem } = this.$listeners;
    const hi = h("i", { class: "el-icon-copy-document" });
    const hCopy = h(
      "span",
      {
        class: "drawing-item-copy",
        title: "复制",
        on: {
          click: (event) => {
            copyItem(currentItem, list);
            event.stopPropagation();
          },
        },
      },
      [hi]
    );

    const hDi = h("i", { class: "el-icon-delete" });
    const hDelete = h(
      "span",
      {
        class: "drawing-item-delete",
        title: "删除",
        on: {
          click: (event) => {
            deleteItem(index, list);
            event.stopPropagation();
          },
        },
      },
      [hDi]
    );

    return [hCopy, hDelete];
  },
};
const layouts = {
  colFormItem(h, currentItem, index, list) {
    const { activeItem } = this.$listeners;
    const config = currentItem.__config__;
    const child = renderChildren.apply(this, arguments);
    let className =
      this.activeId === config.formId
        ? "drawing-item active-from-item"
        : "drawing-item";
    if (this.formConf.unFocusedComponentBorder)
      className += " unfocus-bordered";
    let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null;
    if (config.showLabel === false) labelWidth = "0";

    return h(
      "el-col",
      {
        props: { span: config.span },
        class: className,
        nativeOn: {
          click: (event) => {
            activeItem(currentItem);
            event.stopPropagation();
          },
        },
      },
      [
        h(
          "el-form-item",
          {
            props: {
              "label-width": labelWidth,
              label: config.showLabel ? config.label : "",
              required: config.required,
            },
          },
          [
            h("render", {
              props: { key: config.renderKey, conf: currentItem },
              on: {
                input: (event) => {
                  this.$set(config, "defaultValue", event);
                },
              },
            }),
            child,
          ]
        ),
        components.itemBtns.apply(this, arguments),
      ]
    );

    // return (
    //     <el-col span={config.span} class={className}
    //         nativeOnClick={event => { activeItem(currentItem); event.stopPropagation() }}>
    //         <el-form-item label-width={labelWidth}
    //             label={config.showLabel ? config.label : ''} required={config.required}>
    //             <render key={config.renderKey} conf={currentItem} onInput={event => {
    //                 this.$set(config, 'defaultValue', event)
    //             }}>
    //                 {child}
    //             </render>
    //         </el-form-item>
    //         {components.itemBtns.apply(this, arguments)}
    //     </el-col>
    // )
  },
  rowFormItem(h, currentItem, index, list) {
    const { activeItem } = this.$listeners;
    const config = currentItem.__config__;
    const className =
      this.activeId === config.formId
        ? "drawing-row-item active-from-item"
        : "drawing-row-item";
    let child = renderChildren.apply(this, arguments);
    if (currentItem.type === "flex") {
      child = h(
        "el-row",
        {
          props: {
            type: currentItem.type,
            justify: currentItem.justify,
            align: currentItem.align,
          },
        },
        child
      );
      // child = <el-row type={currentItem.type} justify={currentItem.justify} align={currentItem.align}>
      //     {child}
      // </el-row>
    }

    const doms = h("el-col", { props: { span: config.span } }, [
      h(
        "el-row",
        {
          props: { gutter: config.gutter },
          class: className,
          nativeOn: {
            click: (event) => {
              activeItem(currentItem);
              event.stopPropagation();
            },
          },
        },
        [
          h("span", { class: "component-name" }, config.componentName),
          h(
            "draggable",
            {
              props: {
                list: config.children || [],
                animation: 340,
                group: "componentsGroup",
              },
              class: "drag-wrapper",
            },
            child
          ),
          components.itemBtns.apply(this, arguments),
        ]
      ),
    ]);

    console.log(doms);
    return doms;
    // return (
    //     <el-col span={config.span}>
    //         <el-row gutter={config.gutter} class={className}
    //             nativeOnClick={event => { activeItem(currentItem); event.stopPropagation() }}>
    //             <span class="component-name">{config.componentName}</span>
    //             <draggable list={config.children || []} animation={340}
    //                 group="componentsGroup" class="drag-wrapper">
    //                 {child}
    //             </draggable>
    //             {components.itemBtns.apply(this, arguments)}
    //         </el-row>
    //     </el-col>
    // )
  },
  raw(h, currentItem, index, list) {
    const config = currentItem.__config__;
    const child = renderChildren.apply(this, arguments);
    return h(
      "render",
      {
        props: { key: config.renderKey, conf: currentItem },
        on: {
          input: (event) => {
            this.$set(config, "defaultValue", event);
          },
        },
      },
      child
    );
    // return <render key={config.renderKey} conf={currentItem} onInput={event => {
    //     this.$set(config, 'defaultValue', event)
    // }}>
    //     {child}
    // </render>
  },
};

function renderChildren(h, currentItem, index, list) {
  const config = currentItem.__config__;
  if (!Array.isArray(config.children)) return null;
  return config.children.map((el, i) => {
    const layout = layouts[el.__config__.layout];
    if (layout) {
      return layout.call(this, h, el, i, config.children);
    }
    return layoutIsNotFound.call(this);
  });
}

function layoutIsNotFound() {
  throw new Error(`没有与${this.currentItem.__config__.layout}匹配的layout`);
}

export default {
  components: {
    render,
    draggable,
  },
  props: ["currentItem", "index", "drawingList", "activeId", "formConf"],
  render(h) {
    const layout = layouts[this.currentItem.__config__.layout];
    
    if (layout) {
      return layout.call(
        this,
        h,
        this.currentItem,
        this.index,
        this.drawingList
      );
    }
    return layoutIsNotFound.call(this);
  },
};
</script>